export default function(key) {
  const map = {
    CryptoTransfer: require('@/images/pay-type/Bank transfer.png'),
    alipay: require('@/images/pay-type/alipay-small.png'),
    wechatpay: require('@/images/pay-type/wechat-pay-small.png'),
    unionpay: require('@/images/pay-type/union-pay-small.png'),
    AdvCash: require('@/images/pay-type/AdvCash.png'),
    'Alfa cash-in': require('@/images/pay-type/Alfa cash-in.png'),
    Alipay: require('@/images/pay-type/Alipay.png'),
    'Bank transfer': require('@/images/pay-type/Bank transfer.png'),
    'Cardless cash': require('@/images/pay-type/Cardless cash.png'),
    'Cash (in person)': require('@/images/pay-type/Cash (in person).png'),
    'Cash deposit': require('@/images/pay-type/Cash deposit.png'),
    Efecty: require('@/images/pay-type/Efecty.png'),
    'Gift card': require('@/images/pay-type/Gift card.png'),
    IMPS: require('@/images/pay-type/IMPS.png'),
    'Interac e-Transfer': require('@/images/pay-type/Interac e-Transfer.png'),
    'International wire': require('@/images/pay-type/International wire.png'),
    'M-PESA': require('@/images/pay-type/M-PESA.png'),
    'Mercado Pago': require('@/images/pay-type/Mercado Pago.png'),
    MoneyGram: require('@/images/pay-type/MoneyGram.png'),
    Other: require('@/images/pay-type/Other.png'),
    PayPal: require('@/images/pay-type/PayPal.png'),
    Paytm: require('@/images/pay-type/Paytm.png'),
    Pingit: require('@/images/pay-type/Pingit.png'),
    QIWI: require('@/images/pay-type/QIWI.png'),
    'SEPA transfer': require('@/images/pay-type/SEPA transfer.png'),
    Skrill: require('@/images/pay-type/Skrill.png'),
    Swish: require('@/images/pay-type/Swish.png'),
    TransferWise: require('@/images/pay-type/TransferWise.png'),
    UPI: require('@/images/pay-type/UPI.png'),
    Venmo: require('@/images/pay-type/Venmo.png'),
    WebMoney: require('@/images/pay-type/WebMoney.png'),
    'WeChat Pay': require('@/images/pay-type/WeChat Pay.png'),
    'Western Union': require('@/images/pay-type/Western Union.png'),
    YandexMoney: require('@/images/pay-type/Yandex.Money.png'),
    Velo: require('@/images/pay-type/Velo.png'),
    'Google Pay': require('@/images/pay-type/Google Pay.png'),
    default: require('@/images/pay-type/Other.png'),
  };

  return map[key] ? map[key] : map.default;
}
